/**
 * Created by LouGaZen on 2016-09-09.
 */

/* eslint-disable */


angular.module('RCP').factory('spaceMethod', ['request', function(request) {
    var fsUrl = DYCONFIG.fs.rUrl;
    var courseUrl = DYCONFIG.course.rUrl;
    var ssoUrl = DYCONFIG.sso.rUrl;
    var extraUrl = DYCONFIG.extra.rUrl;
    var pes2Url= DYCONFIG.pes2.rUrl;
    var dmsUrl= DYCONFIG.studyCircle.rUrl;
    var imsdUrl= DYCONFIG.chat.rUrl;
    var countUrl = DYCONFIG.count.rUrl;
    var orderUlr = DYCONFIG.order.rUrl;
    var appraiseUrl = DYCONFIG.appraise.rUrl;

    var recruitUrl = DYCONFIG.recruit && DYCONFIG.recruit.rUrl || dmsUrl; // DYCONFIG.recruit.rUrl;


    return {

        /**
         * ----------------------------资源管理相关接口----------------------------
         */
        //列出该用户所有文件 api->https://api.gdy.io/module.html?key=File%20System/#github_com_Centny_gfs_gfsapi_ListFile
        listFile: function(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/listFile',
                params: arg_params
            }, arg_filter || {}));
        },

        //添加文件夹/目录 api->https://api.gdy.io/module.html?key=File%20System/#github_com_Centny_gfs_gfsapi_AddFolder
        addFolder: function(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/addFolder',
                params: arg_params
            }, arg_filter || {}));
        },

        //修改文件/目录信息 api->https://api.gdy.io/module.html?key=File%20System/#github_com_Centny_gfs_gfsapi_UpdateFile
        updateFile: function(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/updateFile',
                params: arg_params
            }, arg_filter || {}));
        },

        //删除文件/目录 api->https://api.gdy.io/module.html?key=File%20System/#github_com_Centny_gfs_gfsapi_RemoveFile
        removeFile: function(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/removeFile',
                params: arg_params
            }, arg_filter || {}));
        },

        //列出用户试卷或内容 api->https://api.gdy.io/module.html?key=%E8%AF%95%E9%A2%98%E5%BA%93/#w_gdy_io_dyf_wcms_artapi_ListArticle
        listArticle: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/listArticle',
                params: arg_params
            }, arg_filter || {}));
        },

        //列出所有题目 api->https://api.gdy.io/module.html?key=%E8%AF%95%E9%A2%98%E5%BA%93/#w_gdy_io_dyf_wcms_artapi_SearchItem
        searchItem: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'art/api/searchItem',
                params: arg_params
            }, arg_filter || {}))
        },

        //导入试题 api->https://api.gdy.io/module.html?key=%E6%A8%A1%E7%89%88%E5%AF%BC%E5%85%A5%E5%AF%BC%E5%87%BA/#w_gdy_io_dyf_course_courseapi_ImportExam2
        importExam: function (arg_params, arg_filter) {
            if (angular.isDefined(arg_params)) {
                return courseUrl + 'usr/api/importExam2?token=' + rcpAid.getToken() + '&folder=' + arg_params.folder;
            }
        },

        //预览后确定 api->https://api.gdy.io/module.html?key=%E6%A8%A1%E7%89%88%E5%AF%BC%E5%85%A5%E5%AF%BC%E5%87%BA/#w_gdy_io_dyf_course_courseapi_ImportExam2
        confirmImport: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/importExam2',
                params: arg_params
            }, arg_filter || {}))
        },

        //列出列出用户试卷（new） api->https://api.gdy.io/module.html?key=%E8%AF%95%E9%A2%98%E5%BA%93/#w_gdy_io_dyf_wcms_esapi_ListPaper
        listPaper: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/listPaper',
                params: arg_params
            }, arg_filter || {}))
        },

        //获取图片显示路径
        transImgUrl: function(id) {
            return DYCONFIG.fs.down + '?mark=' + id + '&token=' + rcpAid.getToken();
        },

        delExam: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/delExam',
                params: arg_params
            }, arg_filter || {}))
        },

        updateFileParent: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/updateFileParent',
                params: arg_params
            }, arg_filter || {}))
        },

        /**
         * --------------------------资源管理相关接口 end--------------------------
         */

        /**
         * 获取个人中心数据（老师和学生） https://api.gdy.io/module.html?key=%E4%B8%AA%E4%BA%BA%E4%B8%BB%E9%A1%B5/#
         */
        getPersonalCenter: function(argParams, argFilter) {
            argParams.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: courseUrl + 'usr/api/personalHomePage',
                params: argParams
            };
            return request(angular.extend(option, argFilter || {}));
        },
        isTeacher: function(argParams, argFilter) {
            argParams.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: courseUrl + 'usr/api/isTeacher',
                params: argParams
            };
            return request(angular.extend(option, argFilter || {}));
        },

        /**
         * 获取uinfo.js返回的attrs信息
         * @returns {*|data.attrs|{certification}|{pass}|reqData.attrs|{basic}}
         */
        getUserAttrs: function () {
            if (UINFO && UINFO.usr && UINFO.usr.attrs) {
                return UINFO.usr.attrs;
            }
        },

        /**
         * 获取用户信息 api： https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_ssoUinfo
         * @param params
         * @param filter
         * @returns {*}
         */
        userInfo: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'sso/api/uinfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 更新用户信息 api: https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_ssoUpdate
         * @param data
         * @param filter
         * @returns {*}
         */
        updateUser: function (data, filter) {
            var option = {
                method: 'POST',
                url: ssoUrl + 'usr/api/update',
                params: {
                    token: rcpAid.getToken()
                },
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 购买更新用户信息
         * @param data
         * @param filter
         * @returns {*}
         */
        updateBuyOrg: function (data, filter) {
            var option = {
                method: 'POST',
                url: recruitUrl + 'usr/api/updateOrg',
                params: {
                    token: rcpAid.getToken()
                },
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * [机构移除机构用户] api https://api.gdy.io/module.html?key=%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_uas_adm_admapi_RemoveOrgUser
         * @param  {[type]} data   [description]
         * @param  {[type]} filter [description]
         * @return {[type]}        [description]
         */
        removeOrgUser: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: imsdUrl + 'usr/api/removeOrgUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        /**
         * 发送验证码给手机 api：https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_tloginSendPhoneMessage
         * @param params
         * @param filter
         * @returns {*}
         */
        sendMessage: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'tlogin/api/sendMessage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        /**
         * 获取验证码图片   api: https://api.gdy.io/module.html?key=%E7%94%A8%E6%88%B7/#w_gdy_io_dyf_uas_ucs_sso_RequestMark
         * @return {[type]}        [description]
         */
        requestMark: function(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'pub/api/requestMark',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 绑定手机 api：https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_tloginBindUserPhone
         * @param params
         * @param filter
         * @returns {*}
         */
        bindPhone: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'tlogin/api/bindPhone',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 修改密码 api：https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_tloginResetPassword
         * @param params
         * @param filter
         * @returns {*}
         */
        resetPassword: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'tlogin/api/resetPwd',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 修改密码 api 用旧密码改：https://api.gdy.io/module.html?key=%E7%94%A8%E6%88%B7/#w_gdy_io_dyf_uas_ucs_sso_ChangePassword
         * @param params
         * @param filter
         * @returns {*}
         */
        changePassword: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'usr/api/changePassword',
                params: params,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            return request(angular.extend(option, filter || {}));
        },



        // 获取实名认证列表 api:https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_certificationGCertList
        GCertList: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'cert/api/list',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        // 实名认证 api:https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_certificationUCertStatus
        UCertStatus: function (data, filter) {
            var option = {
                method: 'POST',
                url: ssoUrl + 'cert/api/update',
                params: {
                    token: rcpAid.getToken()
                },
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 搜索用户 api: https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_ssoSearch
         * @param params
         * @param filter
         * @returns {*}
         */
        searchUser: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: (params.orgClass ? imsdUrl : ssoUrl) + 'usr/api/search',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 创建用户 api: https://api.gdy.io/#w_gdy_io_dyf_uas_adm_admapiCreateUser
         * @param args
         * @param filter
         * @returns {*}
         */
        createUser: function (args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'adm/api/createUser',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 更新用户权限 api: https://api.gdy.io/#w_gdy_io_dyf_uas_adm_admapiUpdateRole
         * @param params
         * @param filter
         * @returns {*}
         */
        updateRole: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'adm/api/updateRole',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 更改学号/工号/IOS deviceToken api:https://api.gdy.io/module.html?key=%E7%94%A8%E6%88%B7/#w_gdy_io_dyf_uas_ucs_sso_UpdatePrivate
         * @param data
         * @param filter
         * @returns {*}
         */
        updatePrivate: function (data, filter) {
            data.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/updatePrivate',
                params: data
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 查找用户 api: https://api.gdy.io/#w_gdy_io_dyf_uas_adm_admapiFindUser
         * @param params
         * @param filter
         * @returns {*}
         */
        findUser: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'adm/api/findUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 批量更新用户 api: https://api.gdy.io/#w_gdy_io_dyf_uas_adm_admapiUpdateAllUser
         * @param params
         * @param filter
         * @returns {*}
         */
        updateAllUser: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'adm/api/updateAllUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },



        //----------------------机构相关---------------------- BEGIN



        // 申请加入机构 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiApplyIntoOrg
        applyIntoOrg : function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/applyIntoOrg',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 获取机构列表 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiListOrgs
         * @param params
         * @param filter
         * @returns {*}
         */
        getOrgList: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/listOrgs',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        // 列出用户已申请加入的机构 api: https://api.gdy.io/#w_gdy_io_dyf_uas_ucs_ssoListUserOrg
        getlistOrgUser: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/listUserOrg',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 创建机构 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiCreateOrg
         * @param params
         * @param filter
         * @returns {*}
         */
        createOrg: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/createOrg',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 更改机构 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiUpdateOrg
         * @param args
         * @param filter
         * @returns {*}
         */
        updateOrg: function (args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'adm/api/updateUser',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },

        // 检测用户是否存在 api->https://api.gdy.io/module.html?key=%E7%94%A8%E6%88%B7/#w_gdy_io_dyf_uas_ucs_sso_Exist
        exist: function (arg_params, arg_filter) {
            return request(angular.extend({
                method: 'GET',
                url: ssoUrl + 'sso/api/exist',
                params: arg_params
            }, arg_filter || {}));
        },

        /**
         * 创建机构用户 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiCreateOrgMembers
         * @param params
         * @param filter
         * @returns {*}
         */
        createOrgMember: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/createOrgMembers',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 获取所有标签 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiGetAllTags
         * @param params
         * @param filter
         * @returns {*}
         */
        getAllTags: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/getAllTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 获取所有标签 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiListOrgMembers
         * @param params
         * @param filter
         * @returns {*}
         */
        getOrgMember: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/listOrgMembers',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 创建标签 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiCreateOrgMemTags
         * @param params
         * @param filter
         * @returns {*}
         */
        createOrgTag: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/createOrgMemTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 编辑和删除标签 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiMdyOrgMemTag
         * @param params
         * @param filter
         * @returns {*}
         */
        modifyTag: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/mdyOrgMemTag',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 更改机构成员信息 api: https://api.gdy.io/#w_gdy_io_dyf_uas_orgManage_orgapiModifyOrgMembers
         * @param params
         * @param filter
         * @returns {*}
         */
        modifyMembers: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/modifyOrgMembers',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 机构管理员审核是否通过 api: https://api.gdy.io/#w_gdy_io_dyf_uas_adm_admapiVerifyOrgUser
         * @param params
         * @param filter
         * @returns {*}
         */
        verifyOrgUser: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'adm/api/verifyOrgUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 创建群组 api: https://api.gdy.io/module.html?key=%E7%8F%AD%E7%BA%A7%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_dmsapi_CreateGroup
         * @param params
         * @param filter
         * @returns {*}
         */
        createGroup: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'usr/api/createGroup',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 修改群组 api: https://api.gdy.io/module.html?key=%E7%8F%AD%E7%BA%A7%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_dmsapi_UpdateGroups
         * @param args
         * @param filter
         * @returns {*}
         */
        updateGroup: function (args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: dmsUrl + 'usr/api/updateGs',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },
        
        /**
         * 重置用户到群组 api: https://api.gdy.io/module.html?key=%E7%8F%AD%E7%BA%A7%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_ims_group_groupapi_ResetGroup
         * @param args
         * @param filter
         * @returns {*}
         */
        resetGroup: function (args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: imsdUrl + 'usr/api/resetGroup',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },


        //----------------------机构相关----------------------  END

        //----------------------举报相关---------------------- BEGIN

        /**
         * 获取举报列表 api: https://api.gdy.io/#w_gdy_io_dyf_extra_extraapi
         * @param params
         * @param filter
         * @returns {*}
         */
        getReportList: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: extraUrl + 'usr/api/listInfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
         * 处理举报信息 api: https://api.gdy.io/#w_gdy_io_dyf_extra_extraapi
         * @param params
         * @param filter
         * @returns {*}
         */
        handleInfo: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: extraUrl + 'usr/api/handleInfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        // 发起一个举报、投诉 api: https://api.gdy.io/module.html?key=%E4%B8%BE%E6%8A%A5/#w_gdy_io_dyf_extra_extraapi_ReportInfo
        reportInfo: function (params, filter) {
              params.token = rcpAid.getToken();
              var option = {
                method: 'GET',
                url: extraUrl + 'usr/api/reportInfo',
                params: params
              };
              return request(angular.extend(option, filter || {}));
        },
        //----------------------举报相关---------------------- END

        //---------------------- manage-index ----------------------
        //获取首页列表并拿出数据 https://api.gdy.io/#w_gdy_io_dyf_pes2_pesapiListPage
        getIndexList:function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'usr/api/listPage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //获取指定插件数据 https://api.gdy.io/#w_gdy_io_dyf_pes2_pesapiLoadItem
        loadItem:function (params, filter) {
            //params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'pub/api/loadItem',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //保存页面数据（基本设置） https://api.gdy.io/#w_gdy_io_dyf_pes2_pesapiUpdatePage
        updatePage: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/updatePage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //更新某一插件 https://api.gdy.io/#w_gdy_io_dyf_pes2_pesapiUpdateItem
        updateItem: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/updateItem',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //发布某一插件 https://api.gdy.io/#w_gdy_io_dyf_pes2_pesapiReleasePage
        releasePage: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/releasePage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        /**
         * 搜索相关联的课程和tags 详见api https://api.gdy.io/#w_gdy_io_dyf_pes_pesapiSearchRelated
         */
        searchCourse: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'pub/api/searchTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //创建首页 https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_pes2_pesapi_CreatePage
        createPage: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/createPage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //删除一个首页 https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_pes2_pesapi_DeletePage
        deletePage: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/deletePage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //加载搜索分类 https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_pes2_pesapi_LoadAllTags
        getSearchClassify: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'pub/api/loadAllTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //更新搜索分类  https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_pes2_pesapi_UpdateTags
        updateTags:function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/updateTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //---------------------- manage-index ----------------------
        //绑定微信登陆信息 api https://api.gdy.io/module.html?key=%E7%AC%AC%E4%B8%89%E6%96%B9%E7%99%BB%E5%BD%95/#w_gdy_io_dyf_uas_ucs_sso_thirdlogin_ThirdLogin
        bindWx: function(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: DYCONFIG.sso.rUrl + 'pub/api/thirdLogin',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //解绑微信 api https://api.gdy.io/module.html?key=%E7%AC%AC%E4%B8%89%E6%96%B9%E7%99%BB%E5%BD%95/#w_gdy_io_dyf_uas_ucs_sso_thirdlogin_Unbind
        unbindWx: function(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: DYCONFIG.sso.rUrl + 'usr/api/thirdUnbind',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //创建帖子/回复帖子/点赞  https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_dms_dmsapi_CreateDiscuss
        createDiscuss: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: dmsUrl + 'usr/api/createDiscuss',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //搜索帖子  https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_dms_dmsapi_SearchDiscussV
        searchDiscuss: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'pub/api/searchV',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //删除帖子/删除回复/取消点赞  https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_dms_dmsapi_RemoveDiscuss
        removeDiscuss: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'usr/api/delDiscuss',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //获取顺序回复形式帖子详情 https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_dms_dmsapi_GetDiscussDetail
        discussDetail: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'pub/api/getDetail',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //更新资讯/帖子 https://api.gdy.io/module.html?key=default/#w_gdy_io_dyf_dms_dmsapi_UpdateDiscuss
        updateDiscuss: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: dmsUrl + 'usr/api/updateDiscuss',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //---------------------------------运营分析相关 START---------------------------------------------------------------------------

        //课程信息统计 https://api.gdy.io/module.html?key=%E7%BB%9F%E8%AE%A1/#w_gdy_io_dyf_course_courseapi_StatTeacher
        statTeacher: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: countUrl + 'usr/api/statTeacher',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //运营课程统计列表 https://api.gdy.io/module.html?key=%E7%BB%9F%E8%AE%A1/#w_gdy_io_dyf_count_countapi_StatCourse
        statCourse: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: countUrl + 'usr/api/statCourse',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //企业列表 ：https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/
        //#w_gdy_io_dyf_dms_recruit_rctapi_ListCompany
        listCompany: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listCompany',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ListCompanyRecruits
       // 职位匹配详情
        listCompanyRecruits: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listCompanyRecruits',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_FindOrder
        //   获取订单详情
        admlistOrder: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listOrder',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ListRecruitDelivery
        //   匹配名单：
        listRecruitDelivery: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listRecruitDelivery',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
        //https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_FindOrder
        //   获取订单详情：
        listfindOrder: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'adm/api/findOrder',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },


        //---------------------------------运营分析相关 START---------------------------------------------------------------------------

        /**
         * ----------------------------简历相关接口----------------------------
         */
        createResume: function (arg_data, arg_filter) {
            return request(angular.extend({
                method: 'POST',
                url: dmsUrl + 'usr/api/createResume',
                params: {
                    token: rcpAid.getToken()
                },
                data: arg_data
            }, arg_filter || {}))
        },

        updateResume: function (arg_data, arg_filter) {
            return request(angular.extend({
                method: 'POST',
                url: dmsUrl + 'usr/api/updateResume',
                params: {
                    token: rcpAid.getToken()
                },
                data: arg_data
            }, arg_filter || {}))
        },

        searchResume: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: dmsUrl + 'usr/api/searchResume',
                params: arg_params
            }, arg_filter || {}))
        },
        /**
         * --------------------------简历相关接口 end--------------------------
         */

        /**
        * --------------------------- IM 相关接口 ---------------------------
        */

      /**
       * 获取通讯录
       * @param params
       * @param filter
       */
        findContact: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
              method: 'GET',
              url: courseUrl + 'usr/api/findContact',
              params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        /**
        * --------------------------- IM 相关接口 end ---------------------------
        */

        /**
         * ----------------------------警报相关接口----------------------------
         */
        listWarning: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: countUrl + 'usr/api/listWarning',
                params: arg_params
            }, arg_filter || {}))
        },

        loadWarning: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: countUrl + 'usr/api/loadWarning',
                params: arg_params
            }, arg_filter || {}))
        },

        updateWarning: function (arg_data, arg_filter) {
            return request(angular.extend({
                method: 'POST',
                url: countUrl + 'usr/api/updateWarning',
                params: {
                    token: rcpAid.getToken()
                },
                data: arg_data
            }, arg_filter || {}))
        },

        updateCharacter: function (arg_param, arg_filter) {
            arg_param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/updateCharacter',
                params: arg_param
            }, arg_filter || {}))
        },
        /**
         * --------------------------警报相关接口 end--------------------------
         */

        /**
         * ----------------------------职位相关接口----------------------------
         */


        //审核招聘 api->https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_VerifyRecruit
        verifyRecruit: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/verifyRecruit',
                params: arg_params
            }, arg_filter || {}))
        },

        //创建招聘，发布招聘信息   api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_CreateRecruit
        createRecruit: function (args, filter) {
            if(!args.param) args.param = {};
            args.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/createRecruit',
                params: args.param,
                data: args.data
            }, filter || {}));
        },

        //更新招聘信息   api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_UpdateRecruit
        updateRecruit: function(args,filter){
            if(!args.param) args.param = {};
            args.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/updateRecruit',
                params: args.param,
                data: args.data
            },filter || {}))
        },

        //职位列表   api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ListRecruit
        listRecruit: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/listRecruit',
                params: params
            },filter || {}))
        },

        //加载招聘详情   api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_LoadRecruit
        loadRecruit: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'pub/api/loadRecruit',
                params: params
            },filter || {}))
        },

        //下架、发布、删除职位  api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ChangeRecruit
        changeRecruit: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/changeRecruit',
                params: params
            },filter || {}))
        },

        // 发起面试邀请 api->https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_InviteResume
        inviteResume: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/inviteResume',
                params: arg_params
            }, arg_filter || {}))
        },

        //操作投递的简历  api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ChangeDeliver
        changeDeliver: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/changeDeliver',
                params: params
            },filter || {}))
        },

        //操作面试邀请  api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ChangeInvite
        changeInvitation: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: dmsUrl + 'usr/api/changeInvite',
                params: params
            },filter || {}))
        },

        /**
         * --------------------------职位相关接口 end--------------------------
         */

        resumeLoad: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/loadResume',
                params: params
            },filter || {}))
        },
        resumeUpdate: function (params, filter) {
            if(!params.param) params.param = {}; 
            params.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/updateResume',
                params: params.param,
                data: params.data
            }, filter || {}))
        },
        resumeSelectLoad: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'pub/api/loadSearchTags',
                params: params
            },filter || {}))
        },
        listDelivery: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/listDelivery',
                params: params
            },filter || {}))
        },
        listInvitation: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/listInvitation',
                params: params
            },filter || {}))
        },
        changeInvite: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: dmsUrl + 'usr/api/changeInvite',
                params: params
            },filter || {}))
        },
        listPost: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: pes2Url + 'pub/api/loadPage',
                params: params
            },filter || {}))
        },

        configCombo: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/configCombo',
                params: arg_params
            }, arg_filter || {}));
        },

        // 投递简历
        // api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_DeliverResume
        deliverResume: function (params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/deliverResume',
                params: params
            },filter || {}))
        },

        // 招聘机构首页详情 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_LoadCompany
        loadRecruitCompany: function (params, filter) {
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'pub/api/loadCompany',
                params: params
            },filter || {}))
        },

        // 管理员列出套餐列表 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_ListCombo
        listCombo: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/listCombo',
                params: params
            }, filter || null));
        },

        // 加载运营配置 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_LoadAllocation
        loadAllocation: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/loadAllocation',
                params: params
            }, filter || null));
        },

        // 更新运营配置 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_UpdateAllocation
        updateAllocation: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/updateAllocation',
                params: params,
            }, filter || null));
        },

        // 创建招聘套餐 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_CreateCombo
        createCombo: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/createCombo',
                params: params,
            }, filter || null));
        },

        // 创建招聘套餐 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_UpdateCombo
        updateCombo: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/updateCombo',
                params: params,
            }, filter || null));
        },

        // 创建招聘套餐 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_RemoveCombo
        removeCombo: function (params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/removeCombo',
                params: params,
            }, filter || null));
        },

        /**
         * 获取文件信息
         * https://api.gdy.io/module.html?key=File%20System/#github_com_Centny_gfs_gfsapi_FSH_ListInfo
         * @param params
         * @param filter
         * @returns {*}
         */
        listFileInfo: function (params,filter){
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: fsUrl + 'pub/api/listInfo',
                params: params
            };
            return request(angular.extend(option,filter || {}));
        },

        contactLoad: function(params,filter){
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/lookResume',
                params: params
            },filter || {}))
        },
        
        //------------------------------简历订单 start-----------------------------------------
        //列出订单 api-> https://api.gdy.io/#w_gdy_io_dyf_order_orderapiListOrder
        listOrder: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },

        //通过订单id或订单ono获取订单 api-> https://api.gdy.io/#w_gdy_io_dyf_order_orderapiFindOrder
        findOrder: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/findOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },

        //管理员通过订单id或订单ono获取订单 api-> https://api.gdy.io/#w_gdy_io_dyf_order_orderapiFindOrder
        admFindOrder: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/findOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },
        

        // 取消订单 api-> https://api.gdy.io/#w_gdy_io_dyf_order_orderapiCancelOrder
        cancelOrder: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: orderUlr + 'usr/api/cancelOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },

        // 创建课程订单 api-> https://api.gdy.io/#w_gdy_io_dyf_course_courseapiCreateCourseOrder
        createOder: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/buy',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },

        // 加载套餐详情 api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_LoadCombo
        loadCombo: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/loadCombo	',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },

        // //管理员列出订单
        // admListOrder: function (arg_params, arg_filter) {
        //     arg_params.token = rcpAid.getToken();
        //     var option = {
        //         method: 'GET',
        //         url: dmsUrl + 'adm/api/listOrder',
        //         params: arg_params
        //     };
        //     return request(angular.extend(option, arg_filter || {}))
        // },

        // 购买前加载订单信息 api-> https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_LoadOrderInfo
        loadOrderInfo: function (arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/loadOrderInfo',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}))
        },

        // 更改合同信息 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_UpdateContract
        updateContract: function (params, filter) {
            params = params || {};
            params.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/updateContract',
                params: params.param,
                data: params.data
            }, filter || null));
        },

        // 下载、预览合同 api => https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_DownContract
        downContract: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/downContract',
                params: params
            };
            return request(angular.extend(option, filter || {}))
        },
        // 发表评论  https://api.gdy.io/#w_gdy_io_dyf_appraise_appapiPublishComment
        publishRctComment: function (data, filter) {
            var params = {};
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: recruitUrl + 'usr/api/publishComment',
                params: params,
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        // 加载评论  https://api.gdy.io/#w_gdy_io_dyf_appraise_appapiLoadComment
        loadComment: function (params, filter) {
            params.token = rcpAid.getToken();
            var option  ={
                method: 'GET',
                url: appraiseUrl + 'pub/api/loadComment',
                params: params
            }
            return request(angular.extend(option, filter || {}));
        },

        // 加载招聘职位的评论 请求域名不同 https://api.gdy.io/module.html?key=%E6%8B%9B%E8%81%98%E7%AE%A1%E7%90%86/#w_gdy_io_dyf_dms_recruit_rctapi_LoadComment
        loadRctComment: function (params, filter) {
            params.token = rcpAid.getToken();
            var option  ={
                method: 'GET',
                url: recruitUrl + 'pub/api/loadComment',
                params: params
            }
            return request(angular.extend(option, filter || {}));
        },

        //------------------------------简历订单 end-----------------------------------------

        // 加载教师评价职位的评论
        groupCrsAppraise: function (params, filter) {
            params.token = rcpAid.getToken();
            var option  ={
                method: 'GET',
                url: courseUrl + 'usr/api/groupCrsAppraise',
                params: params
            }
            return request(angular.extend(option, filter || {}));
        },

        listWritingPart: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listWritingPart',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },


        listWritingPartDetail: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listWritingPartDetail',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        loadWritingHeadDetail: function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/loadWritingPartDetailHeader',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listManual : function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'pub/api/listManual',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        makeManual : function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/makeManual',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //人才配置列出职位，选择职位
        rctVRList : function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/verifyRecruitList',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        //人才配置列出职位，选择职位
        rctListRsm : function (params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listResume',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        registerUser: function (params, filter) {
            var option = {
                method: 'POST',
                url: ssoUrl + 'sso/api/create',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },
    };
}])

.run(function(service, spaceMethod) {
    service.expand('spaceMethod', function() {
        return spaceMethod;
    });
});



// WEBPACK FOOTER //
// ./src/recruit/src/service/space.js